import env from "../utils/helpers/functions/env";

const conf = { 
    siteUrl     : env('REACT_APP_PUBLICSITE'),   
    apiAdmin    : env('REACT_APP_APIURL'),       
    dataServer  : env('REACT_APP_DATA'),         
    googleId    : env('REACT_APP_GOOGLE_ID'),
    defOptimizioWidth : 1500,

    defLofin    : env('REACT_APP_DEF_LOGIN'),
    defPass     : env('REACT_APP_DEF_PASS'),

    /** Default document title for order file attachments (without extension) */
    orderFileName: env('REACT_APP_ORDER_FILE_NAME') || '',

    mobileTitle: env('MOBILE_TITLE') || '',
    mobileDescription: env('MOBILE_DESCRIPTION') || '',
} 

export default conf; 